import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

import { Banner } from '../home/models/banner.model';

@Injectable({
  providedIn: 'root',
})
export class BannerService {
  private http = inject(HttpClient);

  public url: string;
  public headers = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor() {
    this.url = environment.apiURL;
  }

  getAll() {
    return this.http.get<Banner[]>(this.url + 'banners/?is_active=true', this.headers);
  }

  getPartsDynamic() {
    return this.http.get(this.url + 'banners/', this.headers);
  }
}
